/**
 * timelineのリストを渡して古い順の場合trueを返す
 * @param firstDate リストの最初の要素の日付
 * @param lastDate リストの最後の要素の日付
 * @returns 古い順だった場合trueを返す
 */
export function isOldSortTimelineList(firstDate: string, lastDate: string): boolean {
    let isOld = false;
    const array = ["月前", "日前", "時間", "分"];
    if (firstDate.includes("日前") && (lastDate.includes("時間") || lastDate.includes("分"))) {
        isOld = true;
    } else if (firstDate.includes("時間") && lastDate.includes("分")) {
        isOld = true;
    } else if (
        firstDate.includes("月前") &&
        (lastDate.includes("日前") || lastDate.includes("時間") || lastDate.includes("分"))
    )
        for (let i = 0; i < array.length; i++)
            if (firstDate.includes(array[i]) && lastDate.includes(array[i])) {
                const firstNum = firstDate.replace(array[i], "");
                const lastNum = lastDate.replace(array[i], "");
                if (firstNum > lastNum) {
                    isOld = true;
                }
            }
    return isOld;
}
